import actionTypes from './actionTypes'
import config from '../../../config/config'
import moment from 'moment'

const {
  PLAN_DETAILS
} = actionTypes

const APIurl = `${config.URI}/api/v1/get_fvcontract`

function planStatus(data) {
  let contractStatus = ''
  if (data.domain.status == 'expire') {
    if (!data.expire_flag && data.domain.trial) {
      contractStatus = 'トライアル(有効)'
    } else if (data.expire_flag && data.domain.trial) {
      contractStatus = 'トライアル(期限切れ)'
    } else if (!data.expire_flag && !data.domain.trial) {
      contractStatus = '本契約(有効)'
    } else if (data.expire_flag && !data.domain.trial) {
      contractStatus = '本契約(期限切れ)'
    }
  } else if (data.domain.status == 'valid') {
    contractStatus = '本契約(有効)'
  } else if (data.status == 'invalid') {
    contractStatus = '本契約(無効)'
  }
  return contractStatus
}

export function fetchPlanDetails(token) {
  return function (dispatch) {
    return fetch(`${APIurl}`, {
      method: 'GET',
      headers: {
        'Authenticity-Token': token,
        'Content-Type': 'application/json'
      }
    })
      .then((temp) => temp.json())
      .then(res => {
        if (res.status && res.status === 'success') {
          let data = {}
          if (res.data.domain) {
            data.companyName = res.data.domain.name
            data.concurrency = res.data.domain.connections
            data.expirationDate = moment(res.data.domain.expire).format('YYYY-MM-DD')
            data.recordStorage = '5GB'
            data.currentAccount = res.data.domain.max_account_num
            data.domainUrlName = res.data.domain.fv_domains_name
            data.status = res.data.domain.status
            data.max_room_num_per_user = res.data.domain.max_room_num_per_user
            data.contractStatus = planStatus(res.data)
            data.fvlite_auto_trial = res.data.domain.fvlite_auto_trial
            data.created_at = res.data.domain.created_at
            data.expiry_days = res.data.domain.expiry_days
            data.fvDomainType = res.data.domain.fvdomain_type
            data.enableIPFilter = res.data.domain.enable_ipaddress_filter
            data.enableWebinar = res.data.domain.enable_webinar === 1 ? true : res.data.domain.enable_webinar === 0 ? false : res.data.domain.enable_webinar
            data.enableConference = res.data.domain.enable_conference === 1 ? true : res.data.domain.enable_conference === 0 ? false : res.data.domain.enable_conference
            data.ipAddresses = res.data.domain.whitelisted_ip_addresses
            data.fvDomainOwner = res.data.domain.user_id
            data.campaign = res.data.domain.campaign,
            data.admin_guest_url = res.data.domain.admin_guest_url
          }
          dispatch({type: PLAN_DETAILS, data})
        }
      })
      .catch((error) => {
        console.error(error)
      })
  }
}





// WEBPACK FOOTER //
// src/components/PlanDetails/actions/index.js